/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import styles from "./RMDSummary.module.scss";

import React from "react";
import { compose } from "redux";
import { withRouter } from "react-router";
import { useSelector, useDispatch } from "react-redux";

import BreakdownChart from "../../Balances/BreakdownChart";
import Button from "../../../../Button/Button";
//import Phone from "../../../Phone/Phone";
import { dollars, cents } from "../../../../../utils/dashboard-utils";
//import {
//  TOLL_FREE_NUMBER,
//} from "../../../../settings/settings";
import { appendBasePath } from "../../../../../utils/nav.utils";
// import { getIsDisbursementType } from "../../../../redux/modules/existingAutomatics/existingAutomatics.selectors";
import {
  openModal as openModalAction,
  DELETE_MODAL,
} from "../../../../../redux/modules/modals/modals.module";

import {
  getExistingRMDinfo,
  getIsRMDBalanceAndAmountIsZero,
  getIsRMDPending
} from "../../../../../redux/modules/RMD/RMDSetting.selectors";
import config from "../../../../../config/config"
import {
  doesEverySystematicHaveAnAgreement,
  getIsRMDSpecialPayee,
  getIsRMDFundNonIRA,
  doesUserLEGoToTrust,
} from "../../../../../redux/modules/UserFunds/userFunds.selectors";
import existingRMDCheckmark from '../../../../../assets/images/existing-rmd-checkmark.svg';
const RMD_Summary = ({
  isYTDColumnsShown,
  totalRMD,
  displaySetupLink,
  rmdYear,
  amountDist,
  amountDistToDate,
  setUpRmd,
  history,
  pendingRMD,
}) => {
  const accountBalance = () => {
    return (
      <div>
        <span className={styles["rmdBalance"]}>${dollars(totalRMD)}</span>
        <span className={styles["balanceCents"]}>.{cents(totalRMD)}</span>
      </div>
    );
  };
  const dispatch = useDispatch();
  const isPending = useSelector(getIsRMDPending);
  const sytematicsMatch = useSelector(doesEverySystematicHaveAnAgreement);
  const lblFirstLegendPercent =
    Math.trunc((amountDist / (amountDist + amountDistToDate)) * 100) / 100;
  const lblSecondLegendPercent = 1 - lblFirstLegendPercent;
  const showlblFirstLegend = true;
  const amt1 = dollars(amountDist) + "." + cents(amountDist);
  const amt2 = dollars(amountDistToDate) + "." + cents(amountDistToDate);
  const showlblSecondLegend = true;
  const RMDBalanceAndAmountIsZero = useSelector(getIsRMDBalanceAndAmountIsZero);
  const isRMDSpecialPayee = useSelector(getIsRMDSpecialPayee);
  const isRMDFundNonIRA = useSelector(getIsRMDFundNonIRA);
  const userLETrust = useSelector(doesUserLEGoToTrust);
  const rmdIsHidden = useSelector(getExistingRMDinfo)?.some((fund) => fund.hidden);
  const isAutoRMDPending = isPending.pending;
  const size = 125;
  const strokewidth = 25;
  const newSetUp = <>
      <Button
        id="start-auto-rmd"
        type="primary"
        size="medium"
        onClick={(e) => history.push(appendBasePath("/start"))}
      >
        Set up Auto-RMD
      </Button>
      <div className={styles["existing-automatic-container"]}>
        <a
          href={`${config.url}/usis/transactions/automatic`}
          className={styles["existing-automatic-link"]}
        >
          View Existing Automatic Details
        </a>
      </div>
  </>;
  const displayEditDelete = isAutoRMDPending  ? (
    <div className={styles["pending-text-container"]}>
      <div className={styles["pending-text"]}>
        Your Auto-RMD is being processed, please allow up to 5 business days.
      </div>
    </div>
  ) : (
    userLETrust || RMDBalanceAndAmountIsZero || isRMDSpecialPayee  || isRMDFundNonIRA || !sytematicsMatch || rmdIsHidden ?
      (
        <div className={styles["set-up-text-container"]}>
          <div className={styles["set-up-text"]}>
            <img
              src={existingRMDCheckmark}
              alt=""
              className={styles['existing-checkmark']}
            />
            Your Auto-RMD is in progress
          </div>
        </div>
      ) : (
    <div className={styles["rmd-setup-container"]}>
      <div className={styles["rmd-heading"]}>
        YOUR AUTO-RMD IS IN PROGRESS
      </div>
      <div className={styles["option-container"]}>
        <button
          id="edit-auto-rmd"
          onClick={(e) => {
            //dispatch(moduleActions.applicationDataLoading());
            history.push(appendBasePath("/edit/destination"));
          }}
          className={styles["option-btns"]}
        >
          Edit
        </button>
        <div className={styles["vertical-break"]} />
        <button
          id="delete-auto-rmd"
          onClick={(e) =>
            dispatch(
              openModalAction(DELETE_MODAL, { isEdit: true })
            )
          }
          className={styles["option-btns"]}
        >
          Delete
        </button>
      </div>
    </div>
      )
  );
  return (
    <div id="RMD-Summary" className={styles["card"]}>
      <div className={styles["legal-notice"]}>
        <div className={styles["emphasis"]}>2022 RMD Update</div>
        The IRS released final regulations, effective January 1, 2022, updating
        the lifetime distribution tables, which should be used for calculating
        Requirement Minimum Distributions (RMDs) for 2022 and beyond. Generally,
        the new tables project longer lifespans and, therefore, lower the amount
        of RMDs.
      </div>
      <div className={styles["container"]}>
        <div className={`${styles["RMDinfo"]} balance`}>
          <div className={styles["yearTitle"]}>
            <h4>
              your <span>{rmdYear} </span> required minimum distribution{" "}
            </h4>
          </div>
          {accountBalance()}
          <div>
            <h4>Year Estimate based on accounts </h4>
          </div>
          <div className={styles["estimateBorder"]}></div>
          {isYTDColumnsShown ? (
            <span>
              <div className={styles["disamount"]}>
                <span>
                  Amount Distributed to Date: <sup>1</sup>
                </span>
                <span className={styles["amount"]}>${amt1}</span>
              </div>
              <div className={styles["amountBorder"]}></div>
              <div className={styles["disamount"]}>
                <span>Amount Remaining:</span>
                <span className={styles["amount remaining"]}>${amt2}</span>
              </div>
              <div className={styles["amountBorder"]}></div>
            </span>
          ) : null}
        </div>
        {isYTDColumnsShown && (
          <div className={`${styles["breakdown"]} balance`}>
            <div className={styles["yearTitle"]}>
              <h4>RMD Breakdown</h4>
            </div>
            <BreakdownChart
              size={size}
              strokewidth={strokewidth}
              value={lblFirstLegendPercent}
              showlblFirstLegend={showlblFirstLegend}
              lblFirstLegendPercent={lblFirstLegendPercent}
              showlblSecondLegend={showlblSecondLegend}
              lblSecondLegendPercent={lblSecondLegendPercent}
            />
          </div>
        )}
        {isYTDColumnsShown && (
          <div className={styles["summarySectionBorder"]}></div>
        )}
        <div
          className={
            (isYTDColumnsShown
              ? styles["summaryCol"]
              : styles["summaryColmd"]) + " pure-u-sm-1-1 balance"
          }
        >
          <div className={styles["rmd-setup-container"]}>
            <div className={styles["rmd-heading"]}>AUTO-RMD TOOL</div>
            <div className={styles["rmd-content"]}>
              Create a recurring program to automatically recalculate and distribute
              your RMD every year.
            </div>
            {setUpRmd || rmdIsHidden ? (
              displayEditDelete
              ) : (
                newSetUp
              )}
            <div className={styles["rmd-options-heading"]}>ADDITIONAL RMD OPTIONS</div>
            {setUpRmd ? (
              isPending.pending ? (
                <div className={styles["rmd-options-container"]}>
                  <a
                    href="https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["additional-rmd-options"]}
                  >
                    View Qualified Charitable Distribution (QCD) Form
                  </a>
                </div>
              ) : (
                <>
                  <div className={styles["rmd-options-container"]}>
                    <a
                      href={`${config.url}/usis/transactions/automatic`}
                      className={styles["existing-automatic-link"]}
                    >
                      View Existing Automatic Details
                    </a>
                  </div>
                  <div className={styles["rmd-options-container"]}>
                    <a
                      href="https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles["additional-rmd-options"]}
                    >
                      View Qualified Charitable Distribution (QCD) Form
                    </a>
                  </div>
                </>
              )
             ) : (
               <>
                 <div className={styles["rmd-options-container"]}>
                   <a
                     className={styles["additional-rmd-options"]}
                     href={`${config.url}/usis/transactions/sell`}
                   >
                     Start a One-Time Distribution
                   </a>
                 </div>
                 <div className={styles["rmd-options-container"]}>
                   <a
                     href="https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf"
                     target="_blank"
                     rel="noopener noreferrer"
                     className={styles["additional-rmd-options"]}
                   >
                     View Qualified Charitable Distribution (QCD) Form
                   </a>
                 </div>
               </>
            )}
            <div className={styles["rmd-footer-content"]}>
              You are responsible for all withdrawals, including any automatic
              withdrawals, that may not be reflected here.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(withRouter)(RMD_Summary);
